import { gsap } from 'gsap';
import { initials, enter } from '../animations';

export function pauseEnter(el) {
  const banner = el.querySelector('.ui-pause__banner');
  const text = el.querySelector('.ui-pause__score');
  const buttonLeft = el.querySelector('.button--left');
  const buttonRight = el.querySelector('.button--right');
  const tl = gsap.timeline();

  initials.get('fade')(banner);
  initials.get('fade')(text);
  initials.get('roundedButton')(buttonLeft);
  initials.get('roundedButton')(buttonRight);

  tl.addLabel('start')
    .add(enter.get('fade')(banner), 'start')
    .add(enter.get('fade')(text), 'start+=0.3')
    .add(enter.get('roundedButton')(buttonLeft), 'start+=0.6')
    .add(enter.get('roundedButton')(buttonRight), 'start+=0.6');

  return tl;
}

export function pauseLeave(el) {
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, { opacity: 0, ease: 'bloom' });

  return tl;
}
